<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import SkillForm from "@components/skill-form";

export default {

    page: {
        title: 'Сценарии',
        meta: [{ name: 'description', content: appConfig.description }],
    },

    props: {
        is_popup: { type: Boolean, value: false },
    },

    components: {SkillForm, Layout, PageHeader },

    data() {
        return {
            tableData: [],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: null,
            sortBy: 'id',
            sortDesc: false,
            fields: [
                { key: 'id', label: 'ID', sortable: true },
                { key: 'name', label: 'Название', sortable: true },
                { key: 'user_data', label: 'Пользователь', sortable: false },                
                { key: 'updated_at', label: 'Обновлено', sortable: true },
                { key: 'action', label: ''}
            ],
            tableLoading: true,
            watch: false,

            editSkillPopup: {
              visible: false,
              uuid: null,
            }
        }
    },
    computed: {
        total_rows() {
            return this.$store.getters['skills/GET_SKILLS_TOTAL_ROWS'];
        },
        table_data() {
            this.tableLoading = false;
            return this.$store.getters['skills/GET_SKILLS_TABLE_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
        session_item(){
            return this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        }

    },

    watch: {
        sortBy: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        sortDesc: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        perPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangePerPage();
                }
            }
        },
        currentPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangeCurrentPage();
                }
            }
        },
    },

    async mounted() {
                
        if(this.session_user_item && this.session_user_item.role === 'administrator'){
            this.fields = [
                { key: 'id', label: 'ID', sortable: true },
                { key: 'name', label: 'Название', sortable: true },
                { key: 'user_data', label: 'Пользователь', sortable: false },
                { key: 'dev_data', label: 'Разработчик', sortable: false },
                { key: 'updated_at', label: 'Обновлено', sortable: true },
                { key: 'action', label: ''}
            ];
        }        
        await this.getData();
    },

    methods: {
        async onFiltered() {
            this.currentPage = 1;
            await this.getData();
        },
        async onSorted(){
            await this.getData();
        },
        async onChangePerPage(){
            this.currentPage = 1;
            await this.getData();
        },
        async onChangeCurrentPage(){
            await this.getData();
        },
        async getData(){
            this.tableLoading = true;
            let data_send = {
                'limit'    : this.perPage,
                'page'     : this.currentPage,
                'sortBy'   : this.sortBy,
                'sortDesc' : this.sortDesc === false ? 'ASC' : 'DESC',
                'filter'   : this.filter,
                'filterOn' : JSON.stringify(this.filterOn)
            }
            await this.$store.dispatch('skills/FETCH_SKILLS_LIST', data_send);
            this.watch = true;
        },
        async delItem(uuid){
            await this.$store.dispatch('skills/FETCH_SKILLS_DELETE', {uuid: uuid});
            await this.getData();
            return false;
        },
        async selectItem(uuid){
            await this.$parent.$parent.$parent.$parent.$parent.loadSkill(uuid);
            return false;
        },
        openEditPopup (uuid) {
          this.editSkillPopup.visible = true;
          this.editSkillPopup.uuid = uuid
        },
        closeEditPopup () {
          this.editSkillPopup.visible = false
          this.getData()
        }
    },
}
</script>

<template>
    <div>
        <b-modal
            v-model="editSkillPopup.visible"
            centered
            size="lg"
            :title="'Редактировать сценарий'"
            title-class="font-18"
            hide-footer
        >
          <skill-form :action="'edite'" :uuid="editSkillPopup.uuid" @close="closeEditPopup" />
        </b-modal>
        <p class="text-muted font-13 mb-4"></p>
        <div class="row mb-md-2">
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                        Показывать&nbsp;
                        <b-form-select
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;записей
                    </label>
                </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                >
                    <label class="d-inline-flex align-items-center">
                        Поиск:
                        <b-form-input
                            v-model="filter"
                            type="search"
                            @change="onFiltered()"
                            placeholder="Введите текст..."
                            class="form-control form-control-sm ml-2"
                        ></b-form-input>
                    </label>
                </div>
            </div>
        </div>
        <!-- Table -->
        <div class="table-responsive mb-0">
            <b-table
                :items="table_data"
                :fields="fields"
                responsive="sm"
                current-page="1"
                :class = "tableLoading ? 'loading' : ''"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :no-local-sorting="true"
            >
                <template #cell(action)="row">
                    <div style="text-align: right;">
                        <a v-if="is_popup && row.item.version === '2'" href="javascript:void(0)" @click="selectItem(row.item.uuid)" :id="row.item.id+'_select'" class="btn btn-light btn-sm">
                            <b-tooltip :target="row.item.id+'_select'" placement="top">Выбрать</b-tooltip>
                            <i class="uil uil-check"></i>
                        </a>
                        <a v-if="!is_popup && (row.item.user_id === session_user_item.id || row.item.owner_id === session_user_item.id || session_user_item.role === 'administrator')" :id="row.item.id+'_edit'" class="btn btn-light btn-sm" @click="openEditPopup(row.item.uuid)">
                          <b-tooltip :target="row.item.id+'_edit'" placement="top">Редактировать</b-tooltip>
                          <i class="uil uil-pen mr-1"></i>
                        </a>
                        <router-link v-if="!is_popup && row.item.version === '1' && (row.item.user_id === session_user_item.id || row.item.owner_id === session_user_item.id || session_user_item.role === 'administrator')" :to="{ name: 'Skills.edit', params: { skill_uuid: row.item.uuid, copy: true }}" :id="row.item.id+'_edit'" class="btn btn-light btn-sm">
                            <b-tooltip :target="row.item.id+'_edit'" placement="top">Редактировать</b-tooltip>
                            <i class="uil uil-pen mr-1"></i>
                        </router-link>
                        <router-link v-if="!is_popup" :id="row.item.id+'_mindMap'" :to="{ name: 'Mindmap.edit', params: { type: 'skill', uuid: row.item.uuid } }" class="btn btn-light btn-sm">
                          <b-tooltip :target="row.item.id+'_mindMap'" placement="top">Редактор сценария</b-tooltip>
                          <i class="feather uil uil-sitemap"/>
                        </router-link>
                        <router-link v-if="!is_popup && (row.item.user_id === session_user_item.id || row.item.owner_id === session_user_item.id || session_user_item.role === 'administrator')" to="#" @click.native="delItem(row.item.uuid)" :id="row.item.id+'_del'" class="btn btn-light btn-sm">
                            <b-tooltip :target="row.item.id+'_del'" placement="top">Удалить</b-tooltip>
                            <i class="uil uil-trash-alt"></i>
                        </router-link>
                    </div>
                </template>
            </b-table>
        </div>
        <div class="row">
            <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-left"
                >
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="total_rows"
                            :per-page="perPage"
                        ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.table-responsive-sm{
    transition: all .5s;
}
.table-responsive-sm.loading{
    opacity: 0.3;
}
</style>